import type { TDictObject } from 'src/api/directories/types';
import type { TLabelValue } from 'src/shared/entities/abstract-control-entities';
import { Label } from 'src/shared/entities/control-entities';
import { hasValue } from 'src/shared/utils/common';
import type { Directories } from 'src/store/directories/directories.store';

import type { TLabelRaw, TSavedFormValue } from '../types';

function isSavedLabel(obj: TSavedFormValue): obj is TLabelValue {
  if (obj === null || typeof obj !== 'object') return false;
  if ('label' in obj && 'value' in obj) return true;
  return false;
}

type TMapLabelItemOptions = {
  item: TLabelRaw;
  directory: TDictObject[] | null;
  directories: Directories;
  savedValue?: TSavedFormValue;
};

export const mapLabelItem = ({ item, directories, savedValue, directory }: TMapLabelItemOptions): Label => {
  const initialValue = (() => {
    if (!hasValue(savedValue)) {
      return undefined;
    }

    if (directory && item.refObjectAttr) {
      const dirValue = directory.find((dv) => dv.id === savedValue);

      if (!dirValue) {
        console.error('cannot find corresponding directoryValue');
        return undefined;
      }

      return {
        label: dirValue.data[item.refObjectAttr],
        value: savedValue,
      };
    } else {
      return {
        label: savedValue?.toString(),
        value: savedValue,
      };
    }
  })();

  const data = {
    type: item.type,
    formElementRefId: item.attrName,
    fieldId: item.fieldId,
    enableIf: item.enableIf,
    visuallyDisabled: item.visuallyDisabled,
    validate: item.validate,
    validationTags: item.validationTags,
    refObjectAttr: item.refObjectAttr,
    refObjectType: item.refObjectType,
    refQuery: item.refQuery,
    updateDictValue: item.updateDictValue,
    checkDictValue: item.checkDictValue,
    computeTags: item.computeTags,
    additionalConditionalAttributes: item.additionalConditionalAttributes,
    calculatedValue: item.calculatedValue,
    directory,
    restrictions: { required: false },
    initialValue: isSavedLabel(initialValue) ? initialValue : undefined,
    numberOfDecimalPlaces: item.numberOfDecimalPlaces,
    label: directories.getFieldLabel(item.fieldId) || undefined,
    placeholder: directories.getFieldPlaceholder(item.fieldId) || undefined,
    nullValue: directories.getFieldNullValue(item.fieldId) || undefined,
  };

  return new Label(data);
};
